// extracted by mini-css-extract-plugin
export default {"sectionTitle":"sectionTitle-NuCWj","workflowsIcon":"workflowsIcon-EB8Eg","info":"info-TngJJ"};